<div class="content-body">
    <app-breadcrumb [breadcrumb]="breadcrumbList"> </app-breadcrumb>
    <div class="container-fluid"> 
        <div class="card">
            
            <div class="card-body p-0">
              <form [formGroup]="searchForm" autocomplete="off">
                <div class="row">
                    <div class="mt-3 ps-4" [ngClass]="!isPropertyOwner ? 'col-md-3' : 'col-md-4'">
                        <div class="mb-3">
                            <ng-select ngDefaultControl [items]="properties" class="select2" value="" placeholder="Select Properties"
                                [typeahead]="searchInput$" [virtualScroll]="true" formControlName="property_id"
                                (scrollToEnd)="onScrollToEnd()">
                                <ng-template #template let-data="data">{{data?.name}}</ng-template>
                            </ng-select>
                        </div>
                    </div>
                    <div class="mt-3" [ngClass]="!isPropertyOwner ? 'col-md-3' : 'col-md-4'" *ngIf="!isPropertyOwner">
                        <ng-select [items]="allOwners" bindValue="uid" bindLabel="fullName" formControlName="owner" [multiple]="false"
                            [searchable]="true" placeholder="search for owner" [dropdownPosition]="'bottom'" [typeahead]="searchInput$"
                            [virtualScroll]="true" (scrollToEnd)="onScrollToEnd()">
                        </ng-select>
                    </div>
                    <div class="mt-3" [ngClass]="!isPropertyOwner ? 'col-md-3' : 'col-md-4'">
                        <select2 ngDefaultControl [data]="cities_list" [templates]="template"
                          class="select2" placeholder="Select city" formControlName="city" (update)="handleSearch('')">
                          <ng-template #template let-data="data">{{data?.name}}</ng-template>
                  </select2>
                    </div>
                    <div class="mt-3 pe-4" [ngClass]="!isPropertyOwner ? 'col-md-3' : 'col-md-4'">
                        <select class="form-select" formControlName="type" (change)="handleSearch('')">
                            <option data-display="Select" value="null" selected>Type</option>
                            <option value="Expense">Expense</option>
                            <option value="Income">Income</option>
                        </select>
                    </div>
                    
                </div>
                <div class="row mb-3">
                    <div class="mt-3 ps-4" [ngClass]="!isPropertyOwner ? 'col-md-3' : 'col-md-4'">
                        <input type="date" class="form-control" formControlName="from_date" placeholder="From Date" (change)="handleSearch('')">
                    </div>
                    <div class="mt-3" [ngClass]="!isPropertyOwner ? 'col-md-3' : 'col-md-4'">
                        <input type="date" class="form-control" formControlName="to_date" placeholder="To Date" (change)="handleSearch('')" [min]="searchForm.get('from_date')?.value">
                    </div>
                    <div class="col-md-2 mt-3 d-flex justify-content-center align-items-center">                   
                        <button class="btn btn-primary btn-sm" type="submit">Search</button>
                    </div>
                    <div class="col-md-2 mt-4">
                        <button class="btn btn-danger btn-sm float-start" type="button" (click)="resetSearchForm()" [disabled]="!disableClear">Clear</button>  
                    </div>
                    
                </div>
              </form>
                

                <div class="row">
                        <div class="col-xl-12">
                        <div class="table-responsive active-projects style-1 ItemsCheckboxSec shorting dataTables_wrapper">
                            <div class="tbl-caption">
                                <h4 class="heading mb-0"></h4>
                                <div>
                                    <a class="btn btn-primary btn-sm me-1" data-bs-toggle="offcanvas" href="javascript:vode(0);">Download</a>
                                    <button type="button" class="btn btn-secondary btn-sm">Email
                                    </button>
                                </div>
                            </div>  
                            <table id="empoloyees-tbl" class="table mb-0">
                                <thead>
                                    <tr> 
                                        <th>Property</th>                                      
                                        <th>Date</th>
                                        <th>Type</th>
                                        <th>Reference</th>
                                        <th>Description</th>
                                        <th>Rent/Security Deposit</th>
                                        <th>Expense/Debit</th>
                                        <th>Company Fee</th>
                                        <th>Income/Credit</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for(item of allData.data; track item){
                                    <tr>  
                                        <td>{{ item.property_name }}</td>
                                        <td>{{ item.date | date:'dd-MM-yyyy' }}</td>
                                        <td>                    
                                            <span>{{ item.type }}</span>             
                                        </td>
                                        <td>{{ item.reference }}</td>
                                        
                                        <td>
                                            <span>{{ item.description }}</span>
                                        </td>  
                                        <td>
                                            <span>{{ item.rent }}</span>
                                        </td>  
                                        <td>
                                            <span>{{ item.expense }}</span>
                                        </td>  
                                        <td>
                                            <span>{{ item.company_fee }}</span>
                                        </td> 
                                        <td>
                                            <span>{{ item.income }}</span>
                                        </td>
                                        
                                    </tr>
                                    }
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th>Total</th>
                                        <th></th>
                                        <th>{{ allData?.total_income }}</th>
                                        <th></th>
                                        <th>Income</th>
                                        <th>{{ allData?.total_income }}</th>
                                        <th>Expense</th>
                                        <th></th>
                                        <th>{{ allData?.total_expense }}</th>
                                    </tr>
                                </tfoot>
                            </table>
                            <div class="dataTables_info" id="example5_info" role="status" aria-live="polite">Showing {{page}} to
                                {{totalRows}} of {{ totalPage }} entries</div>
                            <div class="dataTables_paginate paging_simple_numbers pt-2">
                                <app-pagination [totalPage]="pageCount" [page]="page" (newPage)="pageChange($event)"></app-pagination>
                            </div>
                        </div>                

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


